import SchematicThumbnail from '../UI/schematicThumbnail';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';
import { PropsWithChildren } from 'react';

function MiscPartThumbnail({
   thumbnailUrl,
   title,
   children,
   isOpen,
   onOpen,
}: PropsWithChildren<
   {
      thumbnailUrl: string;
      title: string;
   } & MinimalDisclosure
>) {
   return (
      <SchematicThumbnail thumbnailUrl={thumbnailUrl} title={title} isOpen={isOpen} onOpen={onOpen}>
         {children}
      </SchematicThumbnail>
   );
}

export default MiscPartThumbnail;
